import React, { Component } from "react";
import _ from "lodash";
import IconRestaurants from "material-ui/svg-icons/maps/restaurant";
import IconCategories from "material-ui/svg-icons/action/view-list";
import IconCoupons from "material-ui/svg-icons/action/loyalty";
import IconPushes from "material-ui/svg-icons/social/notifications";
import IconQrCodes from "material-ui/svg-icons/image/camera-alt";
import IconLocations from "material-ui/svg-icons/social/location-city";
import IconSettings from "material-ui/svg-icons/action/settings";
import IconModifiers from "material-ui/svg-icons/image/tune";
import MenuItem from "material-ui/MenuItem";

import Drawer from "material-ui/Drawer";

const menuItems = {
  // dashboard: {
  //   title: 'Dashboard',
  //   icon: <IconDashboard/>,
  //   path: ({ restaurantId }) => `/${restaurantId}`,
  // },
  locations: {
    title: "Locations",
    path: ({ restaurantId }) => `/${restaurantId}/locations`,
    icon: <IconLocations />,
    native: false,
  },
  categories: {
    title: "Categories",
    path: ({ restaurantId }) => `/${restaurantId}/categories`,
    icon: <IconCategories />,
  },
  modifiers: {
    title: "Modifiers",
    path: ({ restaurantId }) => `/${restaurantId}/modifiers`,
    icon: <IconModifiers />,
    native: true,
  },
  restaurantMenu: {
    title: "Products",
    path: ({ restaurantId }) => `/${restaurantId}/menu`,
    icon: <IconRestaurants />,
  },
  coupons: {
    title: "Deals",
    icon: <IconCoupons />,
    path: ({ restaurantId }) => `/${restaurantId}/coupons`,
    native: true,
  },
  push_notifications: {
    title: "Push Notifications",
    icon: <IconPushes />,
    path: ({ restaurantId }) => `/${restaurantId}/pushes`,
    native: true,
  },
  qrcodes: {
    title: "QR Codes",
    icon: <IconQrCodes />,
    path: ({ restaurantId }) => `/${restaurantId}/qrcodes`,
  },
  settings: {
    title: "Settings",
    icon: <IconSettings />,
    path: ({ restaurantId }) => `/${restaurantId}/settings`,
  },
};

class NavigationDrawer extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedItem: "",
      isNative: false,
    };
  }

  handleClick = (path, title) => {
    this.context.router.push(path);
    this.setState({
      selectedItem: title,
    });

    this.props.onItemClicked && this.props.onItemClicked();
  };

  renderItems() {
    const { restaurantId, menuDisabled = true } = this.props;
    const { selectedItem } = this.state;
    console.log({ state: this.state });
    const filteredMenu = _.filter(menuItems, ({ native }) => {
      return this.state.isNative || !native;
    });
    return _.map(filteredMenu, ({ icon, path, title }) => {
      return (
        <MenuItem
          leftIcon={icon || ""}
          disabled={menuDisabled}
          style={title === selectedItem ? { backgroundColor: "#EAEAEA" } : {}}
          onTouchTap={
            menuDisabled
              ? () => {}
              : () => this.handleClick(path({ restaurantId }), title)
          }
        >
          {title}
        </MenuItem>
      );
    });
  }

  async componentDidMount() {
    const { restaurantPath } = this.props;
    try {
      const restaurantSnap = await restaurantPath.get();
      const restaurant = restaurantSnap.data();
      this.setState({
        isNative: !!restaurant.subscription,
      });
    } catch (error) {
      console.log(error);
    }
  }

  render() {
    return (
      <Drawer
        docked={this.props.docked}
        onRequestChange={this.props.onRequestChange}
        open={this.props.open}
        {...this.props}
      >
        {/*<AppBar onLeftIconButtonTouchTap={() => this.props.onRequestChange(false)} title="Menu" />*/}
        {this.renderItems()}
      </Drawer>
    );
  }
}
export default NavigationDrawer;



// WEBPACK FOOTER //
// ./src/components/NavigationDrawer.js